import {call, put} from 'redux-saga/effects';

import axios from 'axios';
import * as lexActionType from '../actionsType/lexLoginDSP.actionType';
import {getBaseUrl} from '../../../core/utility/filter.utility';

function loginWithCLSDSP(reqObj) {
    let url = `${getBaseUrl()}/dsp/login/CATCmaUserAthenticationServletDSP/loginDSP?`;
    if (reqObj.ticket) {
        url += `&ticket=${reqObj.ticket}`;
    }
    // if (reqObj.voucheruuid) {
    //     url += `&voucheruuid=${reqObj.voucheruuid}`;
    // }
    return axios({
        method: 'get',
        url: url
    });
}

export function* loginDSPSaga(request) {
    try {
        const response = yield call(loginWithCLSDSP, request.payload);
        const content = response.data.res;
        yield put({
            type: lexActionType.LEX_LOGINDSP_SUCCESS,
            payload: content
        });
    } catch (error) {
        yield put({
            type: lexActionType.LEX_LOGINDSP_ERROR,
            payload: 'There has been some issue with 3DS Learning Space. Please try after sometime.'
        });
    }
}
